import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../../styles/list-car.css";
import { ENDPOINT } from "../../Services/ENDPOINT";

const CarCard = ({ car, bookingData, onSelect, showSelectBtn = false, droptype }) => {
    if (!car) return null;

    console.log("********", bookingData);

    //   const baseImageUrl = ENDPOINT.base;
    const baseImageUrl = 'https://cabbookigapi.shreeshtech.com';
    const calculation = car.calculation || null;
    const added_additional_price = car.added_additional_price || [];

    const image = car.upload_img
        ? baseImageUrl + car.upload_img
        : "assets/images/blog1.jpg";

    return (
        <div className="col-lg-4 col-md-6 col-12">
            <div >
                <div className="relative-wrapper">
                    {/* <img src={image} alt={car.car_name} className="car-image" /> */}

                    {/* <div className="brand-badge">{car.brand}</div> */}

                    {/* {calculation?.discount_percent > 0 && (
            <div className="discount-badge">
              <i className="fas fa-tag"></i>{" "}
              {calculation.discount_percent}% OFF
            </div>
          )} */}
                </div>

                <div >
                    {/* <h5 className="car-title">{car.car_name}</h5> */}

                    {/* SPECS */}
                    {/* <div className="specs-section">
            <div className="specs-grid">
              <div className="spec-item">
                <i className="fas fa-cog spec-icon"></i>
                <span className="spec-value">{car.gear_type}</span>
                <span className="spec-label">Transmission</span>
              </div>

              <div className="spec-item">
                <i className="fas fa-tachometer-alt spec-icon"></i>
                <span className="spec-value">
                  {car.min_travel_range_km} KM
                </span>
                <span className="spec-label">Included</span>
              </div>

              <div className="spec-item">
                <i className="fas fa-gas-pump spec-icon"></i>
                <span className="spec-value">
                  {car.fule_type?.replace("_", " ")}
                </span>
                <span className="spec-label">Fuel Type</span>
              </div>
            </div>
          </div> */}

                    {/* DETAILS */}
                    <div className="calculation-details">

                        {bookingData?.from?.trim() && bookingData?.to?.trim() && (
                            <div className="route-title">
                                {bookingData.from} → {bookingData.to}
                            </div>
                        )}

                        <div className="calculation-row"></div>

                        {bookingData.rental_duration && (
                            <div className="calculation-row">
                                <span className="value">Rental Duration</span>
                                <span className="value">{bookingData.rental_duration}</span>
                            </div>
                        )}

                        <div className="divider_1"></div>

                        <div className="calculation-row">
                            {/* <span className="label">Car Name</span> */}
                            <span className="value">{car?.car_name}</span>
                        </div>

                        {bookingData.totalDay && (
                            <div className="calculation-row">
                                <span className="label">Total Rental Duration</span>
                                <span className="value">{bookingData.totalDay} Day</span>
                            </div>
                        )}

                        {bookingData.pickup_date && (
                            <div className="calculation-row">
                                <span className="label">Pickup</span>
                                <span className="value">{bookingData.pickup_date}, {bookingData.pickup_time}</span>
                            </div>
                        )}

                        {bookingData.total_distance && (
                            <div className="calculation-row">
                                <span className="label">Total Travel KMs</span>
                                <span className="value">
                                    {droptype === "premium"
                                        ? bookingData?.total_distance * 2
                                        : bookingData?.total_distance} KM
                                </span>                            </div>
                        )}

                        <div className="divider_1"></div>

                        {/* {car.min_travel_range_km && (
                            <div className="calculation-row">
                                <span className="label">Included Kms</span>
                                <span className="value">{car?.min_travel_range_km} KM</span>
                            </div>
                        )} */}
                        {car?.min_travel_range_km && (
                            <div className="calculation-row">
                                <span className="label">Included Kms</span>

                                {calculation.calculation_type === "day_wise" ? (
                                    <span className="value">
                                        {Number(car?.min_travel_range_km) * Number(bookingData?.totalDay || 0)} KM
                                    </span>
                                ) : (
                                    <span className="value">
                                        {car?.min_travel_range_km} KM
                                    </span>
                                )}
                            </div>
                        )}

                        {car.seater && (
                            <div className="calculation-row">
                                <span className="label">Passenger Capacity</span>
                                <span className="value">{car?.seater}</span>
                            </div>
                        )}

                        {car.additional_travel_amount && (
                            <div className="calculation-row">
                                <span className="label">Additional Charge per KM</span>
                                <span className="value">
                                    ₹{car?.additional_travel_amount} / km
                                </span>
                            </div>
                        )}

                        {car.additional_travel_amount_per_hr && (
                            <div className="calculation-row">
                                <span className="label">Additional Charge per Hour</span>
                                <span className="value">
                                    ₹{car.additional_travel_amount_per_hr} / hr
                                </span>
                            </div>
                        )}
                    </div>

                    {/* PRICE CALCULATION */}
                    {calculation ? (
                        <>
                            <div className="calculation-details">
                                {calculation?.rental_type !== "outstation_round" && (
                                    <div className="calculation-row">
                                        <span className="label">Base Price</span>
                                        <span className="value">₹{calculation.base_price}</span>
                                    </div>
                                )}


                                {calculation?.rental_type !== "outstation_round" &&
                                    calculation?.extra_km > 0 && (
                                        <div className="calculation-row">
                                            <span className="label">
                                                Extra KM ({calculation.extra_km} @ ₹{calculation.per_km_price}/km)
                                            </span>
                                            <span className="value">
                                                ₹{calculation.extra_km_charge}
                                            </span>
                                        </div>
                                    )}

                                {/* {!(
                                    bookingData.tripType === "oneway" &&
                                    bookingData.type === "outstation"
                                ) &&
                                calculation.rentalDayPrice > 0 && (
                                    <div className="calculation-row">
                                        <span className="label">
                                            Rental Price ({bookingData.totalDay} D @ ₹
                                            {calculation.perDayRentalPrice}/ Day)
                                        </span>
                                        <span className="value">
                                            ₹{calculation.rentalDayPrice}
                                        </span>
                                    </div>
                                )} */}
                                {!(
                                    (bookingData.tripType === "oneway" &&
                                        bookingData.type === "outstation") ||
                                    calculation.calculation_type === "km_wise"
                                ) &&
                                    calculation.rentalDayPrice > 0 && (
                                        <div className="calculation-row">
                                            <span className="label">
                                                Rental Price ({bookingData.totalDay} D @ ₹
                                                {calculation.perDayRentalPrice}/ Day)
                                            </span>
                                            <span className="value">
                                                ₹{calculation.rentalDayPrice}
                                            </span>
                                        </div>
                                    )}

                                {calculation.total_driver_bata > 0 && (
                                    <div className="calculation-row">
                                        <span className="label">
                                            Driver Bata ({bookingData.totalDay} D @ ₹
                                            {calculation.driver_bata_per_day}/ Day)
                                        </span>
                                        <span className="value">
                                            ₹{calculation.total_driver_bata}
                                        </span>
                                    </div>
                                )}

                                {bookingData.type !== "outstation" &&
                                    calculation.rentalDayPrice > 0 && (
                                        <div className="calculation-row">
                                            <span className="label">
                                                Rental Price ({bookingData.totalDay} D @ ₹
                                                {calculation.perDayRentalPrice}/ Day)
                                            </span>

                                            <span className="value">
                                                ₹{calculation.rentalDayPrice}
                                            </span>
                                        </div>
                                    )}

                                {added_additional_price.map((item, i) => (
                                    <div className="calculation-row" key={i}>
                                        <span className="label">{item.name}</span>
                                        <span className="value">₹{item.amount}</span>
                                    </div>
                                ))}

                                {calculation.discount_amount > 0 && (
                                    <div
                                        className="calculation-row"
                                        style={{ color: "#28a745" }}
                                    >
                                        <span className="label">
                                            Discount ({calculation.discount_percent}%)
                                        </span>
                                        <span className="value">
                                            -₹{calculation.discount_amount}
                                        </span>
                                    </div>
                                )}

                                <div className="calculation-row total">
                                    <span className="label">Total Price</span>
                                    <span className="value">
                                        ₹{calculation.discounted_price}
                                    </span>
                                </div>
                            </div>

                            {/* <div className="price-badge">
                <div className="price-main">
                  Starting From ₹{calculation.discounted_price}
                </div>
              </div> */}
                        </>
                    ) : (
                        // <div className="price-badge">
                        //   <div className="price-main">
                        //     Starting From ₹{car.display_price}
                        //   </div>
                        // </div>
                        <></>
                    )}

                    {/* {showSelectBtn && (
            <button className="details-btn" onClick={onSelect}>
              Select Car <i className="fas fa-arrow-right ms-1"></i>
            </button>
          )} */}
                </div>
            </div>
        </div>
    );
};

export default CarCard;
